import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SubTitle } from '~/pages/Main/index.styled';
import { FlexStack, Text } from '~/components/atomic';
import MainDebate from '~/assets/img/asset/main_debate.png';

export default function CommingSoon() {
  return (
    <>
      <FlexStack spacing={16}>
        <div>
          <SubTitle>Would you rather...?</SubTitle>
        </div>
        <DebateContainer>
          <img src={MainDebate} alt='main_debate' />
          <Text
            as={'span'}
            fontStyle={'poppins.main'}
            color={'content_light_1'}
          >
            AI Debate is
            <br /> Coming soon!
          </Text>
        </DebateContainer>
      </FlexStack>
    </>
  );
}

export const DebateContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    margin-right: ${theme.layout.section_side};

    & > img {
      position: relative;
      width: 100%;
      overflow: hidden;
      border-radius: 16px;
    }

    & > span {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  `}
`;
